import classNames from 'classnames'
import HeaderPage from '../../common/HeaderPage'
import { useHistory } from 'react-router-dom'
import { useEffect } from 'react'

const NoAccess = ({ ...props }) => {
  const history = useHistory()

  useEffect(() => {
    history.push('/')
  }, [history])

  return (
    <>
      <HeaderPage title="нет доступа" />
      <main className={classNames('page-content')}>нет доступа</main>
    </>
  )
}

export default NoAccess
